import { useEffect, useRef, useState } from 'react';
import { Button, Table, Tag, InputNumber, Select, Flex, Space, message, Empty, Divider } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { getAll, create, update, drop } from '../../../../apis/TipoEfectivoApi';

const { Option } = Select;

const TiposEfectivoConfig = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [denominacion, setDenominacion] = useState(null);
  const [tipo, setTipo] = useState(null);
  const [editingId, setEditingId] = useState(null);

  const refreshData = async () => {
    const response = await getAll();
    if (response.ok) {
      setItems(response.payload || []);
    }
    setLoading(false);
  };

  const effectRan = useRef(false);
  useEffect(() => {
    if (!effectRan.current) {
      (async () => {
        await refreshData();
      })();
    }
    return () => (effectRan.current = true);
  }, []);

  const limpiar = () => {
    setDenominacion(null);
    setTipo(null);
    setEditingId(null);
  };

  const fmtDenom = (n) => {
    const s = Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return s.replace(/\.?0+$/, '');
  };

  const guardar = async () => {
    if (!denominacion || denominacion <= 0) {
      message.error('La denominación debe ser mayor a 0');
      return;
    }
    if (!tipo) {
      message.error('Selecciona el tipo (billete o moneda)');
      return;
    }
    let response;
    if (editingId) {
      response = await update({ id: editingId, denominacion, tipo });
    } else {
      response = await create({ denominacion, tipo });
    }
    if (response.ok) {
      message.success(editingId ? 'Denominación actualizada correctamente' : 'Denominación creada correctamente');
      limpiar();
      await refreshData();
    }
  };

  const eliminar = async (item) => {
    const response = await drop(item.id);
    if (response.ok) {
      message.success('Denominación eliminada correctamente');
      if (editingId === item.id) limpiar();
      await refreshData();
    }
  };

  const columns = [
    {
      title: 'Denominación',
      key: 'denominacion',
      render: (_, item) => '$' + fmtDenom(item.denominacion),
    },
    {
      title: 'Tipo',
      dataIndex: 'tipo',
      key: 'tipo',
      render: (tipo) => (tipo === 'billete' ? <Tag color="green">Billete</Tag> : <Tag color="orange">Moneda</Tag>),
    },
    {
      title: 'Usuario',
      dataIndex: 'usuario',
      key: 'usuario',
      render: (usuario) => usuario || '—',
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (_, item) => (
        <Space>
          <Button
            type="primary"
            size="small"
            onClick={() => {
              setEditingId(item.id);
              setDenominacion(Number(item.denominacion));
              setTipo(item.tipo);
            }}
          >
            Editar
          </Button>
          <Button type="primary" size="small" danger onClick={() => eliminar(item)}>
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Divider orientation="left" orientationMargin="0">Tipos de Efectivo</Divider>
      <Flex gap={16} wrap align="center">
        <InputNumber
          min={0.01}
          step={0.01}
          precision={2}
          placeholder="Denominación"
          value={denominacion}
          onChange={(value) => setDenominacion(value)}
          style={{ width: 200 }}
        />
        <Select placeholder="Tipo" value={tipo} onChange={(value) => setTipo(value)} style={{ width: 160 }}>
          <Option value="billete">Billete</Option>
          <Option value="moneda">Moneda</Option>
        </Select>
        <Space>
          <Button type="primary" icon={<PlusOutlined />} onClick={guardar}>
            {editingId ? 'Actualizar' : 'Agregar'}
          </Button>
          {editingId && <Button onClick={limpiar}>Cancelar</Button>}
        </Space>
      </Flex>
      <br />
      {loading ? (
        <p>Loading...</p>
      ) : items.length === 0 ? (
        <Empty description="No hay denominaciones registradas" />
      ) : (
        <Table rowKey="id" dataSource={items} columns={columns} pagination={false} />
      )}
    </>
  );
};

export default TiposEfectivoConfig;